import { type FC, type ReactNode } from 'react';

import { LayoutBlock } from 'shared/components/LayoutBlock';

import styles from './MortgageSection.css';

export interface IMortgageSectionProps {
  children: ReactNode;
  tabs: ReactNode;
  title: string;
}

export const MortgageSection: FC<IMortgageSectionProps> = ({ children, tabs, title }) => {
  return (
    <LayoutBlock id="mortgage-section" title={title}>
      <div className={styles['container']}>
        {tabs}
        {children}
      </div>
    </LayoutBlock>
  );
};
